import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QuillHelperService } from '@sb-tools/typescript/services/quill/quill-helper.service';
import { ThreadElementDTO } from '@sb-tools/typescript/models/dto/thread-element.dto';
import { ReplyUpdateModel } from '@sb-tools/typescript/models/reply-update-model.model';
import { QuillEditorComponent } from 'ngx-quill';
import { FormsModule } from '@angular/forms';
import { LogToolbarControlsClickDirective } from '../../directives/log-toolbar-controls-click.directive';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGComponent } from '../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';

@Component({
    selector: 'app-web-reply-quill-editor',
    templateUrl: './web-reply-quill-editor.component.html',
    styleUrls: ['./web-reply-quill-editor.component.scss'],
    imports: [
        QuillEditorComponent,
        FormsModule,
        LogToolbarControlsClickDirective,
        TooltipModule,
        TranslateModule,
        InlineSVGComponent,
    ],
})
export class WebReplyQuillEditorComponent {
    @Input() id?: string = '';
    @Input() reply: ThreadElementDTO | ReplyUpdateModel;

    @Output() editorCreated: EventEmitter<object> = new EventEmitter();
    @Output() replyChanged: EventEmitter<any> = new EventEmitter();

    isToolbarCollapsed = true;

    constructor(public quillHelperService: QuillHelperService) {}

    onEditorCreated(quill: any): void {
        this.editorCreated.emit(quill);
    }

    toggleToolbarControls(): void {
        this.isToolbarCollapsed = !this.isToolbarCollapsed;
    }
}
